function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
  fill: "#00DCFA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8424 4C9.73176 4 7.93882 5.62353 7.71294 7.71294C5.62353 7.93882 4 9.73176 4 11.8424C4 14.1365 5.86353 16 8.15765 16C10.2682 16 12.0682 14.3765 12.2871 12.2871C14.3765 12.0612 16 10.2682 16 8.15765C16 5.86353 14.1365 4 11.8424 4ZM15.0259 8.62353C14.922 9.30525 14.6029 9.93592 14.1153 10.4235C13.6277 10.9112 12.997 11.2302 12.3153 11.3341V8.62353H15.0259ZM4.97412 11.3765C5.07666 10.6935 5.39509 10.0612 5.88282 9.57221C6.37055 9.08321 7.00198 8.76314 7.68471 8.65882V11.3694H4.97412V11.3765ZM11.3412 12.3153C11.2285 13.0789 10.8449 13.7765 10.2604 14.2806C9.67587 14.7848 8.92952 15.0618 8.15765 15.0612C6.55529 15.0612 5.20706 13.8894 4.97412 12.3153H11.3412ZM11.3765 8.62353V11.3694H8.62353V8.62353H11.3765ZM15.0259 7.68471H8.65882C8.77151 6.9211 9.15514 6.22352 9.73963 5.71937C10.3241 5.21523 11.0705 4.93818 11.8424 4.93882C13.4447 4.93882 14.7929 6.11059 15.0259 7.68471Z",
  fill: "white"
});

var SvgGusd = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGusd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gusd.73ada79d.svg";
export { ForwardRef as ReactComponent };